import { render, staticRenderFns } from "./ameldings-show.vue?vue&type=template&id=3b3dd310&scoped=true&"
import script from "./ameldings-show.vue?vue&type=script&lang=ts&"
export * from "./ameldings-show.vue?vue&type=script&lang=ts&"
import style0 from "./ameldings-show.vue?vue&type=style&index=0&id=3b3dd310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3dd310",
  null
  
)

export default component.exports